<template>
  <div
    class="popup_wrap"
    style="width:1200px; height:410px;"
  >
    <button
      type="button"
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.ONEX050T010.044') }}</h1><!-- Calling Port -->
      <div class="content_box" style="height:260px;">
        <table class="tbl_col font_sm mt10">
          <colgroup>
            <col style="width:5%">
            <col style="width:10%">
            <col style="width:5%">
            <col style="width:5%">
            <col style="width:5%">
            <col style="width:10%">
            <col style="width:5%">
            <col style="width:5%">
            <col style="width:10%">
            <col style="width:10%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.SCHD010P040.054') }}</th><!-- Route -->
              <th>{{ $t('msg.SCHD010P040.055') }}</th><!-- Vessel -->
              <th>{{ $t('msg.SCHD010P040.056') }}</th><!-- Voy No -->
              <th>{{ $t('msg.SCHD010P040.057') }}</th><!-- POL -->
              <th>{{ $t('msg.SCHD010P040.058') }}</th><!-- TRML -->
              <th>{{ $t('msg.SCHD010P040.059') }}</th><!-- ETD -->
              <th>{{ $t('msg.SCHD010P040.060') }}</th><!-- POD -->
              <th>{{ $t('msg.SCHD010P040.058') }}</th><!-- TRML -->
              <th>{{ $t('msg.SCHD010P040.061') }}</th><!-- ETA -->
              <th>{{ $t('msg.SCHD010P040.062') }}</th><!-- Transit -->
            </tr>
          </thead>
          <tbody>
              <tr :key="lvlDiv" v-for="(item, lvlDiv) in callingPort">
                <td>{{ item.rteCd }}</td><!-- Route -->
                <td>{{ item.vslNm }}</td><!-- Vessel -->
                <td>{{ item.etVoyNo }}</td><!-- Voy No -->
                <td>{{ item.polPortCd }}</td><!-- POL -->
                <td>{{ item.polTrmlCd }}</td><!-- TRML -->
                <td>{{ $ekmtcCommon.changeDatePattern(item.polEtd, '.') }}</td><!-- ETD -->
                <td>{{ item.podPortCd }}</td><!-- POD -->
                <td>{{ item.podTrmlCd }}</td><!-- TRML -->
                <td>{{ $ekmtcCommon.changeDatePattern(item.podEta, '.') }}</td><!-- ETA -->
                <td>{{ item.trstList }}</td><!-- Transit -->
              </tr>
          </tbody>
        </table>
      </div>
      <!-- 닫기 -->
      <div class="mt10 text_center">
        <a
          class="button gray lg"
          href="#"
          @click.prevent="$emit('close')"
        >
          {{ $t('msg.SCHD010P040.046') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import vslScheduleInfo from '@/api/rest/schedule/vslScheduleInfo'

export default {
  name: 'VesselScheduleInfoPop',
  components: {
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          blNo: ''
        }
      }
     }
  },
  data: function () {
    return {
      // 콜링포트 리스트
      callingPort: []
    }
  },
  watch: {
    parentInfo () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      await this.getCallingPort(this.parentInfo)
    },
    async getCallingPort (data) {
      await vslScheduleInfo.getCallingPort(data)
        .then(response => {
          if (response.status === 200) {
            this.callingPort = response.data.callingPortList
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.skpY td {
  background-color : #e9bdbd
}
</style>
